import { ref, get, remove } from 'firebase/database';
import { database } from './firebaseConfig';

export async function cleanupOldRooms(): Promise<void> {
  const today = new Date().toDateString();
  if (localStorage.getItem('pp_lastCleanup') === today) return;

  try {
    const snap = await get(ref(database, 'rooms'));
    if (snap.exists()) {
      const startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      const cutoff = startOfToday.getTime();

      const rooms = snap.val() as Record<string, { createdAt: number }>;
      await Promise.all(
        Object.entries(rooms)
          .filter(([, room]) => room.createdAt < cutoff)
          .map(([id]) => remove(ref(database, `rooms/${id}`)))
      );
    }
    localStorage.setItem('pp_lastCleanup', today);
  } catch {
    // non-critical, will retry next load
  }
}
